import { cn } from '../../lib/cn';
import type { DocumentRow } from '../../knowledgecenter/framework';

type Props = { documents?: DocumentRow[] };

export function DocumentationStudioPanel({ documents = [] }: Props) {
  return (
    <div className="space-y-2">
      {documents.map((d) => (
        <div key={d.title} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{d.title}</p>
            <p className="mt-0.5 text-xs text-slate-500">{d.format} · {d.version} · {d.author}</p>
          </div>
          <span className={cn(
            'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
            d.status === 'published' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
            'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
          )}>
            {d.status}
          </span>
        </div>
      ))}
    </div>
  );
}
